import { Injectable } from '@angular/core';
import { Auth } from '../interfaces/auth';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map, of, tap } from 'rxjs';
import authHeader from '../helpers/auth-header';
import { EulaPost } from '../interfaces/termsAndConditions';
import { UserProfile } from '../interfaces/UserProfile';
import { User } from '../interfaces/user';
import { Router } from '@angular/router';

@Injectable({
     providedIn: 'root'
})
export class UserService {
     userProfile: UserProfile | undefined;

     constructor(private http: HttpClient, private router: Router) { }

     refresh(user: Auth) {
          const url: string = `${environment.APP_API_URL}/api/v1/token/refresh`;
          return this.http.post(url, user)
               .pipe(
                    map((response: any) => response),
                    catchError(error => {
                         console.error('Error in refresh() token: ');
                         console.error(error);
                         return Promise.reject(error);
                    })
               );
     }

     isUserProfileCached(username: string): boolean {
          const userProfile = localStorage.getItem('userprofile');
          if (userProfile) {
               this.userProfile = JSON.parse(userProfile) as UserProfile;
               if (this.userProfile.userData.userName === username) {
                    return true;
               }
          }
          return false;
     }

     getUserProfile(username: string): Observable<UserProfile> {
          if (this.isUserProfileCached(username)) {
               return new Observable<UserProfile>(observer => {
                    observer.next(this.userProfile as UserProfile);
                    observer.complete();
               });
          }
          const config = {
               headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': authHeader()
               }
          };

          const url: string = `${environment.APP_API_URL}/api/v1/UserProfile/GetUserProfile?username=${username}`;
          return this.http.get(url, config)
               .pipe(
                    map((response: any) => response),
                    catchError(error => {
                         console.error(`Error in getUserProfile(); ERROR: ${error}`);

                         if (error.response.status === 401) {
                              location.reload();
                         }
                         this.router.navigateByUrl('/signin');
                         return Promise.reject("");
                    })
               );
     }

     submitEula(eulaData: EulaPost) {
          const config = {
               headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': authHeader()
               }
          };

          const url: string = `${environment.APP_API_URL}/api/v1/UserProfile/SubmitEula`;
          return this.http.post(url, eulaData, config).pipe(
               map((response: any) => response),
               tap((response: any) => {
               }),
              catchError((error: any) => {
                console.error(`Error saving Eula response ${error}`);
                return of(null);
                
              })
          );
     }
}
